import React, {useEffect} from "react";
import {EntrantApplication, MyBreadcrumb} from "../../../components";
import {Col, FloatButton, message, Row, Spin} from "antd";
import {useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../store/selector";
import {
  createEducationOrderAction, createSelectedSpecialityActionReset,
  fetchEducationEditOrderAction, fetchEntrantApplicationsAction, fetchGetMarksAction,
  fetchProvincesAction, postEducationOrderXMLActionReset
} from "../../../store/pages/admission/actions";
import {decodeBase64} from "../../../utils/decodeBase64";
import {useTranslation} from "react-i18next";

export const EntrantApplicationPage = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const {t} = useTranslation("admission")

  const education_order_id = searchParams.get("education_order_id");

  let decodedEducationOrder = education_order_id ? decodeBase64(education_order_id) : null

  const {profile: {userProfile: profileData}, admission: {educationOrder, entrantApplications}} = useSelector(selectStore)

  const isExecutor = profileData.data && Array.isArray(profileData.data.roles) && profileData.data.roles.some((item: any) => item === "executor")

  useEffect(() => {
    dispatch(fetchProvincesAction())
    dispatch(postEducationOrderXMLActionReset())
    dispatch(fetchEntrantApplicationsAction());
    dispatch(createSelectedSpecialityActionReset());
  }, []);

  useEffect(() => {
    // if (entrantApplications.data && Array.isArray(entrantApplications.data) && entrantApplications.data.length > 2) {
    //   message.error("Вы уже подали 2 возможные заявки")
    // }
  }, [entrantApplications]);

  useEffect(() => {
    if(profileData.success){
      if (profileData?.data?.id) {
        if (education_order_id) {
          // @ts-ignore
          dispatch(fetchEducationEditOrderAction({
            user_id: profileData.data && profileData.data.id,
            id: decodedEducationOrder,
            iin_check: 0
          }))
          // @ts-ignore
          dispatch(fetchGetMarksAction(decodedEducationOrder))
        } else {
          // @ts-ignore
          dispatch(createEducationOrderAction({user_id: profileData.data.id, is_entrant: !isExecutor}))
        }
      } else {
        message.error({type: "error", duration: 10, content: "Token undefined, please restart page aplication"})
      }
    }
  }, [profileData]);


  return (
    <>

      <MyBreadcrumb isBack title={t("stepOne.title")}/>
      <FloatButton.BackTop visibilityHeight={10}/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <Spin spinning={profileData.loading}>
                <EntrantApplication education_order_id={education_order_id} user_id={profileData.data && profileData.data.id}/>
              </Spin>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}